import React, { Component, useEffect, useState, useRef } from "react";
import {
  RUN_TIME_API_ENDPOINT,
  GetCurrentUserRoles,
  CommonHeaderOption,
} from "../common/common";
import { downloadCSV, Title, useTranslate, useRedirect } from "react-admin";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import Modal from "react-responsive-modal";
import Swal from "sweetalert2";

const CreateBusinessOnUpload = (props) => {
  const inputImgElement = useRef(null);
  const translate = useTranslate();

  const [fileExtError, setFileExtError] = useState(false);
  const [sizeError, setSizeError] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showLoader, setShowLoader] = useState(false);
  const [dataUpload, setDataUpload] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");

  //   componentWillMount() {
  //     const roleData = GetCurrentUserRoles();
  //     if (["$csa", "$ca"].indexOf(roleData[0]) === -1) {
  //       window.location.replace(
  //         window.location.origin + "/#/madagascar_products_list"
  //       );
  //     }
  //   }

  const handleImageChange = (e) => {
    e.preventDefault();
    const selectedFile = inputImgElement?.current?.files;
    const fileExtention =
      selectedFile &&
      selectedFile[0].name.substring(selectedFile[0].name.lastIndexOf(".") + 1);
    console.log("fileExtention", fileExtention, selectedFile[0]);

    const maxSize = 10;

    if (selectedFile[0].size / 1024 / 1024 > maxSize) {
      setFileExtError(false);
      setSizeError(true);
      // this.setState({
      //   fileExtError: false,
      //   sizeError: true,
      // });
    } else if ("csv" !== fileExtention) {
      setFileExtError(true);
      setSizeError(false);
      // this.setState({
      //   sizeError: false,
      //   fileExtError: true,
      // });
    } else {
      setSelectedFile(e.target.files[0]);
      setFileExtError(false);
      setSizeError(false);
      // this.setState({
      //   selectedFile: e.target.files[0],
      //   sizeError: false,
      //   fileExtError: false,
      // });
    }
  };
  const redirect = useRedirect();

  const onSave = () => {
    setShowLoader(true);
    // this.setState({
    //   showLoader: true,
    // });
    const formData = new FormData();

    // Update the formData object
    formData.append("files", selectedFile);
    formData.append("file_name", selectedFile.name);

    const stateData = localStorage.getItem("__state");
    const userData = stateData ? JSON.parse(stateData) : false;
    const options = {};
    options.method = "POST";
    options.headers = {
      Authorization: userData._token,
    };
    options.body = formData;

    const url = `${RUN_TIME_API_ENDPOINT}/businesses/create_business_from_csv`;
    fetch(url, options)
      .then((res) => {
        if (res.status === 401) {
          // localStorage.removeItem("__state");
          window.location.href = "#/login";
        }
        return res.json();
      })
      .then((json) => {
        console.log("json==>", json);
        // const msg = '';
        const msg = json.data ? json.data[0].message : "";
        Swal.fire({
          html: msg,
          icon: "success",
        }).then((result) => {
          if (result.isConfirmed) {
            setShowLoader(false);
            redirect("/");
            // this.setState({
            //   showLoader: false,
            // });
            // window.location.href = "#";
          }
        });
      })
      .catch((error) => {
        Swal.fire({
          html: "Something went wrong. Please try again.",
          icon: "error",
        }).then((result) => {
          if (result.isConfirmed) {
            setShowLoader(false);
            // this.setState({
            //   showLoader: false,
            // });
          }
        });
      });
  };

  const onModalClose = () => {
    setShowModal(false);
    // this.setState({
    //   showModal: false,
    // });
    // window.location.replace(
    //   window.location.origin + "/#/madagascar_products_list"
    // );
  };

  // callExport = (e) => {
  //   const options = CommonHeaderOption();
  //   const apiUrl = RUN_TIME_API_ENDPOINT;
  //   e.preventDefault();
  //   options.method = "GET";
  //   fetch(
  //     `${apiUrl}/madagascar_products_list?filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B%22id%22%2C%22DESC%22%5D`,
  //     options
  //   )
  //     .then((res) => {
  //       return res.json();
  //     })
  //     .then((jsonD) => {
  //       const prodList = jsonD.data;
  //       const csv = convertToCSV({
  //         fields: [
  //           "name",
  //           "client_category_code",
  //           "material_number",
  //           "material_description",
  //           "price_after_tax",
  //           "status",
  //         ],
  //         data: prodList,
  //       });
  //       downloadCSV(csv, "product_price_list");
  //     });
  // };

  console.log("props inside price upload===>", props);
  return (
    <React.Fragment>
      <center>
        <Title
          title={translate(
            "resources.create_business_from_csv.fields.create_business"
          )}
        />
      </center>
      <div className="target-upload-container">
        <label>
          {translate("resources.create_business_from_csv.fields.upload_file")}
        </label>
        <input
          type="file"
          accept=".csv"
          name="flies[]"
          ref={(inputFileImg) => {
            inputImgElement.current = inputFileImg;
          }}
          onChange={handleImageChange}
        />
        {(fileExtError || sizeError) && (
          <div className="valid-file-upload-error">
            {fileExtError && (
              <p>
                {translate(
                  "resources.create_business_from_csv.fields.file_type"
                )}
              </p>
            )}
            {sizeError && (
              <p>
                {translate(
                  "resources.create_business_from_csv.fields.file_size"
                )}
              </p>
            )}
          </div>
        )}
        <div className="valid-file-upload">
          <p>
            {translate("resources.create_business_from_csv.fields.instruction")}{" "}
            :
          </p>
          <ul>
            <li>
              {translate("resources.create_business_from_csv.fields.csv_file")}
            </li>
            <li>
              {translate(
                "resources.create_business_from_csv.fields.file_size_inst"
              )}
            </li>
            <li>
              {translate("resources.create_business_from_csv.fields.wait_msg")}
            </li>
            <li>
              {translate(
                "resources.create_business_from_csv.fields.result_msg"
              )}
            </li>
          </ul>
        </div>
        <div className="upload-file-format-download">
          <p>
            {translate("resources.create_business_from_csv.fields.get_format")}{" "}
            <a
              href="https://clickit-static-files-prod.s3.eu-west-1.amazonaws.com/fille_formats/bulk_business_new.csv"
              target="_blank"
            >
              {translate(
                "resources.create_business_from_csv.fields.click_here"
              )}
            </a>{" "}
            {translate("resources.create_business_from_csv.fields.to_download")}
          </p>
        </div>
        {showLoader && <div className="login-loader" />}
        {!showLoader && (
          <div className="so-save-button">
            <button onClick={onSave} disabled={!selectedFile}>
              {translate("resources.create_business_from_csv.fields.save")}
            </button>
          </div>
        )}
        {showModal && (
          <Modal open={showModal} onClose={onModalClose} center>
            <h3>{message}</h3>
          </Modal>
        )}
      </div>
    </React.Fragment>
  );
};

export default CreateBusinessOnUpload;
